module.exports = __webpack_public_path__ + "img/4club-13.98408036.svg";